import * as React from 'react'
import { isArray } from 'lodash'
import './index.css'

interface IState {
  showView: boolean
}

interface props {
  emptyText: string[] | string
}

/**
 * 券列表（我的券列表、历史券列表、提单券列表）兜底页
 */
export default class EmptyView extends React.Component<props, IState> {
  render () {
    // @ts-ignore
    return (
      <view className="empty-wrap">
        <image className="empty-icon" src="assets://icon/coupon/coupon_list_empty_icon.png" autoRTL></image>
        {(isArray(this.props.emptyText) ? this.props.emptyText : [this.props.emptyText]).map(item => (
          <text className="empty-text">{item}</text>
        ))}
      </view>
    )
  }
}
